var CurrentStatus = $.extend({/* CurrentStatus */}, BaseComponent, {

	componentSelector: '.current-status',

	init: function() {
		$(this.componentSelector).each(this.binding.bind(this));
	},

	binding: function(index, element) {

		var disposed = parseFloat($(element).find('.current-status-bar-graphic').attr('data-disposed'));
		var available = parseFloat($(element).find('.current-status-bar-graphic').attr('data-available'));
		var total = disposed + available;

		$(element).find('.current-status-bar-graphic .available-bar').css('width', Math.round((available / total) * 100) + '%');
	}
})